/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-08-13 17:36:50
 * @FilePath: src/router/index.ts
 * @Description: TypeScript版本 - 自动转换
 */

import { createWebHistory, createRouter } from 'vue-router'
import { translateRouteTitle } from '@/locales/route'
/* Layout */
import Layout from '@/layout'
import { institutionAssetRoutes } from './institutionAssets'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  ...institutionAssetRoutes,
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true,
  },
  {
    path: '/ai-chat',
    component: () => import('@/views/aiChat/index.vue'),
    hidden: true,
    meta: {
      title: '神笔马良',
      titleKey: 'route.aiChat',
    },
  },
  {
    path: '/ai-chat/image-cut-diagram',
    component: () => import('@/views/imageCutDiagram/index.vue'),
    hidden: true,
    meta: {
      title: 'AI抠图',
      titleKey: 'route.imageCutDiagram',
    },
  },
  {
    path: '/ai-schedule',
    component: () => import('@/views/schedule/index.vue'),
    hidden: true,
    meta: {
      title: '排课中心',
      titleKey: 'route.aiSchedule',
    },
  },
  {
    path: '/bot',
    // component: () => import("@/views/login"),
    component: () => import('@/views/application/bot/index.vue'),
    hidden: true,
  },
  {
    path: '/register',
    component: () => import('@/views/register'),
    hidden: true,
  },
  {
    path: '/teachers-and-students',
    component: Layout,
    hidden: true,
    meta: {
      title: '师生管理',
      breadcrumb: true,
    },
    children: [
      {
        path: 'export-records',
        component: () => import('@/views/teachersAndStudents/exportRecords/index.vue'),
        name: 'ExportRecords',
        meta: {
          title: '导出记录',
          activeMenu: '/teachers-and-students/export-records',
        },
      },
    ],
  },
  // 用户反馈前端先行：后端菜单配置上线后自动复用后端项，不重复添加
  {
    path: '/feedback',
    component: Layout,
    hidden: true,
    meta: {
      title: '帮助反馈',
      breadcrumb: true,
    },
    children: [
      {
        path: 'userFeedback',
        component: () => import('@/views/feedback/userFeedback/index.vue'),
        name: 'UserFeedback',
        meta: {
          title: '用户反馈',
          activeMenu: '/feedback/userFeedback',
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    redirect: '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        component: () => import('@/views/entry/index.vue'),
        meta: { noCache: true, breadcrumb: false },
      },
      {
        path: '/no-access',
        component: () => import('@/views/entry/noAccess.vue'),
        meta: { title: '暂无可访问模块', noCache: true },
      },
    ],
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile/index'),
        name: 'Profile',
        meta: { title: '账号设置', icon: 'user', noCache: true, breadcrumb: false },
      },
    ],
  },
  {
    path: '/application',
    // component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'bot/:id(\\d+)',
        component: () => import('@/views/application/bot/index'),
        name: 'bot',
      },
    ],
  },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: '/dashboard/workbench',
  //   name: 'Dashboard',
  //   alwaysShow: true,
  //   meta: {
  //     title: '仪表盘',
  //     icon: 'dashboard',
  //   },
  //   children: [
  //     {
  //       path: 'workbench',
  //       component: () => import('@/views/dashboard/workbench/index.vue'),
  //       name: 'Workbench',
  //       meta: {
  //         title: '工作台',
  //         icon: 'Odometer',
  //         breadcrumb: true,
  //         noCache: false,
  //       },
  //     },
  //   ],
  // },
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: () => import('@/views/system/user/authRole'),
        name: 'AuthRole',
        meta: { title: '分配角色', titleKey: 'route.assignRole', activeMenu: '/system/user' },
      },
    ],
  },
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:edit'],
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户', titleKey: 'route.assignUser', activeMenu: '/system/role' },
      },
    ],
  },
  {
    path: '/system/dict-data',
    component: Layout,
    hidden: true,
    permissions: ['system:dict:list'],
    children: [
      {
        path: 'index/:dictId(\\d+)',
        component: () => import('@/views/system/dict/data'),
        name: 'Data',
        meta: { title: '字典数据', titleKey: 'route.dictData', activeMenu: '/system/dict' },
      },
    ],
  },
  {
    path: '/monitor/job-log',
    component: Layout,
    hidden: true,
    permissions: ['monitor:job:list'],
    children: [
      {
        path: 'index/:jobId(\\d+)',
        component: () => import('@/views/monitor/job/log'),
        name: 'JobLog',
        meta: { title: '调度日志', titleKey: 'route.jobLog', activeMenu: '/monitor/job' },
      },
    ],
  },
  {
    path: '/tool/gen-edit',
    component: Layout,
    hidden: true,
    permissions: ['tool:gen:edit'],
    children: [
      {
        path: 'index/:tableId(\\d+)',
        component: () => import('@/views/tool/gen/editTable'),
        name: 'GenEdit',
        meta: { title: '修改生成配置', titleKey: 'route.genEdit', activeMenu: '/tool/gen' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
})

// 使用全局前置守卫来动态设置标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = translateRouteTitle(to)
  }
  next()
})

export default router
